import React from 'react';

import { Field } from 'react-final-form';

import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import Label from 'components/shared/FormAdapters/FormDefault/Label';
import LabelWrapper from 'components/shared/FormAdapters/FormDefault/Label/Wrapper';
import FormTitle from 'components/shared/Typography/FormTitle';

function SocialLinks() {
  return (
    <>
      <FormTitle hint="Enter your social media links below.">V. Connect with Social</FormTitle>
      <LabelWrapper>
        <Label>Facebook</Label>
      </LabelWrapper>
      <Field
        component={FormGroupAdapter}
        name="facebookLink"
        placeholder="https://www.facebook.com/safariportal"
        type="text"
        parse={(value) => value || null}
      />
      <LabelWrapper>
        <Label>Instagram</Label>
      </LabelWrapper>
      <Field
        component={FormGroupAdapter}
        name="instagramLink"
        placeholder="https://www.instagram.com/safariportalapp"
        type="text"
        parse={(value) => value || null}
      />
      <LabelWrapper>
        <Label>Vimeo</Label>
      </LabelWrapper>
      <Field
        component={FormGroupAdapter}
        name="vimeoLink"
        placeholder="https://vimeo.com/user134112656"
        type="text"
        parse={(value) => value || null}
      />
    </>
  );
}

export default SocialLinks;
